import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import s from './TabNavigation.module.scss';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { IsWidgetAccessible } from '../../utils/widgetManager';
import { push } from 'redux-first-history';

// Enhanced Tab component that properly integrates with redux-first-history
const Tab = ({ selectedPage, pageComponent, url, title }) => {
  const dispatch = useDispatch();
  const isActive = selectedPage === pageComponent;

  const handleClick = (e) => {
    e.preventDefault();
    dispatch(push(url));
  };

  return (
    <Fragment>
      <Link
        className={classNames({ [s.active]: isActive })}
        to={url}
        onClick={handleClick}
      >
        {title}
        {isActive && <span />}
      </Link>
    </Fragment>
  );
};

const TabNavigation = ({ selectedPage, unitSerialNumber, userProfileWidgets, showUnitOverviewTab = false }) => (
  <ul className={s.tabNav}>
    {IsWidgetAccessible(userProfileWidgets, 'UNITOVERVIEW') && showUnitOverviewTab && (
      <li>
        <Tab
          url={`/unit/overview/${unitSerialNumber}/`}
          title={<FormattedMessage id="tabNavigation.unitOverview" defaultMessage="Unit Overview" />}
          selectedPage={selectedPage}
          pageComponent="unitOverview"
        />
      </li>
    )}
    {IsWidgetAccessible(userProfileWidgets, 'PROCESFLOW') && (
      <li>
        <Tab
          url={`/unit/process-flow/${unitSerialNumber}`}
          title={<FormattedMessage id="tabNavigation.processFlow" defaultMessage="Process flow" />}
          selectedPage={selectedPage}
          pageComponent="processFlow"
        />
      </li>
    )}
    {IsWidgetAccessible(userProfileWidgets, 'EVENTLOGSUMMARY') && (
      <li>
        <Tab
          url={`/unit/events/${unitSerialNumber}`}
          title={<FormattedMessage id="tabNavigation.eventLog" defaultMessage="Event Log" />}
          selectedPage={selectedPage}
          pageComponent="eventLog"
        />
      </li>
    )}
    {IsWidgetAccessible(userProfileWidgets, 'UNIT_CONFIGURATION') && (
      <li>
        <Tab
          url={`/unit/unit-configuration/${unitSerialNumber}`}
          title={<FormattedMessage id="tabNavigation.unitConfiguration" defaultMessage="Unit Configuration" />}
          selectedPage={selectedPage}
          pageComponent="unitConfiguration"
        />
      </li>
    )}
    {IsWidgetAccessible(userProfileWidgets, 'UNIT_SETTINGS') && (
      <li>
        <Tab
          url={`/unit/settings/${unitSerialNumber}`}
          title={<FormattedMessage id="tabNavigation.unitSettings" defaultMessage="Unit Settings" />}
          selectedPage={selectedPage}
          pageComponent="unitsettings"
        />
      </li>
    )}
    {IsWidgetAccessible(userProfileWidgets, 'UNIT_SIGNALTRANSLATION') && (
      <li>
        <Tab
          url={`/unit/signal-translations/${unitSerialNumber}`}
          title={<FormattedMessage id="tabNavigation.signalTranslation" defaultMessage="SignalTranslation" />}
          selectedPage={selectedPage}
          pageComponent="signalTranslation"
        />
      </li>
    )}

    {IsWidgetAccessible(userProfileWidgets, 'DATATRENDANALYSIS') && (
      <li>
        <Tab
          url={`/unit/data-trend-analysis/${unitSerialNumber}`}
          title={<FormattedMessage id="tabNavigation.dataTrendAnalysis" defaultMessage="Data trend analysis" />}
          selectedPage={selectedPage}
          pageComponent="dataTrend"
        />
      </li>
    )}
    {IsWidgetAccessible(userProfileWidgets, 'UNITDATAACCESS') && (
      <li>
        <Tab
          url={`/unit/data-analysis/${unitSerialNumber}`}
          title={<FormattedMessage id="tabNavigation.dataAnalysis" defaultMessage="Data Analysis" />}
          selectedPage={selectedPage}
          pageComponent="dataAccess"
        />
      </li>
    )}

    {IsWidgetAccessible(userProfileWidgets, 'UNITREPORT') && (
      <li>
        <Tab
          url={`/unit/reports/${unitSerialNumber}`}
          title={<FormattedMessage id="tabNavigation.reports" defaultMessage="Reports" />}
          selectedPage={selectedPage}
          pageComponent="unitreports"
        />
      </li>
    )}

    {IsWidgetAccessible(userProfileWidgets, 'UNIT_SCHEDULE') && (
      <li>
        <Tab
          url={`/unit/schedule/${unitSerialNumber}`}
          title={<FormattedMessage id="tabNavigation.schedule" defaultMessage="Schedule" />}
          selectedPage={selectedPage}
          pageComponent="unitSchedule"
        />
      </li>
    )}
    {IsWidgetAccessible(userProfileWidgets, 'UNIT_UNIT_SERVICE_TAB') && (
      <li>
        <Tab
          url={`/unit/service/${unitSerialNumber}`}
          title={<FormattedMessage id="tabNavigation.unitService" defaultMessage="Unit Service" />}
          selectedPage={selectedPage}
          pageComponent="unitService"
        />
      </li>
    )}
    {IsWidgetAccessible(userProfileWidgets, 'DAILY_SUMMARY_DATA') && (
      <li>
        <Tab
          url={`/unit/summary/${unitSerialNumber}`}
          title={<FormattedMessage id="tabNavigation.summaryData" defaultMessage="Summary Data" />}
          selectedPage={selectedPage}
          pageComponent="dailySummary"
        />
      </li>
    )}
    {IsWidgetAccessible(userProfileWidgets, 'UNITSTATICDATALIST') && (
      <li>
        <Tab
          url={`/unit/static-data/${unitSerialNumber}`}
          title={<FormattedMessage id="tabNavigation.staticData" defaultMessage="Static Data" />}
          selectedPage={selectedPage}
          pageComponent="staticData"
        />
      </li>
    )}
  </ul>
);

Tab.propTypes = {
  selectedPage: PropTypes.string.isRequired,
  pageComponent: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  title: PropTypes.node.isRequired
};

TabNavigation.propTypes = {
  unitSerialNumber: PropTypes.string,
  selectedPage: PropTypes.string.isRequired,
  userProfileWidgets: PropTypes.array
};

export default TabNavigation;